import React from "react";

import { viewBoardingPagePermissionSet } from "helpers";
import { useTerminalSearchQuery } from "queries";

import { terminalResultItem } from "../resultItems";

import { ReactComponent as TerminalSolutionsIcon } from "static/images/terminal_solutions-search.svg";

const terminalSection = () => {
	return {
		name: "terminalSolutions",
		title: "Terminal Solutions",
		useSearchQuery: useTerminalSearchQuery,
		renderItem: terminalResultItem,
		getIcon: () => <TerminalSolutionsIcon />,
		getLink: ({ merchant_id, id }) =>
			`/merchant/list/info/${merchant_id}/terminal-solutions/${id}/edit`,
		requiredPermissions: viewBoardingPagePermissionSet,
	};
};

export default terminalSection;
